<template lang="pug">
	.app-core--popup
		DxPopup(
			ref="popup",
			:visible.sync="innerPopupVisible"
			:drag-enabled="false"
			:close-on-outside-click="closeOnOutsideClick"
			:show-title="!!title"
			:width="width"
			:height="innerHeight"
			:title="title"
			:animation="{ hide: null, show: null }"
			maxWidth="90%",
			maxHeight="90%",
			:fullScreen="fullScreen",
			@showing="onContentShowing",
			@shown="onContentShown",
			@hidden="$emit('hidden')"
		)
			dx-validation-group.app-core--popup--popup-content.full-height(ref="body", :class="{ 'disabled-controls': busy }")
				PopupBody(v-if="innerPopupVisible && !$scopedSlots['body']", ref="popupBody", @content-changed="onContentChanged")
					slot
					slot(name="header", slot="header")
					slot(name="actions-top", slot="actions-top")
					slot(name="actions-left", slot="actions-left")
					template(slot="actions-right")
						slot(name="actions-right")
						template(v-if="defaultActions")
							DxButton(:text="$tCaption('Cancel', '@actions')", @click="processResult('cancel')", :disabled="busy")
							DxButton(:text="successText || $tCaption('OK', '@actions')", @click="processResult('success')", type="success", :disabled="!validated || busy")
				slot(name="body")
			DxToolbarItem(v-for="button in buttons", widget="dxButton", :options="button", :location="button.location || 'after'")
			DxToolbarItem(v-if="showMaximize", widget="dxButton", :options="buttonOptions", location="after")
			DxToolbarItem(v-if="$scopedSlots['title-before']", template="titleBefore", location="before")
			template(v-slot:titleBefore="{ data }")
				slot(name="title-before")
</template>

<script>
	import $ from 'jquery';
	import DxValidationGroup from 'devextreme-vue/validation-group';
	import { DxPopup, DxToolbarItem  } from 'devextreme-vue/popup';
	import VueTypes from 'vue-types';
	import PopupBody from './PopupBody.vue';
	import DxButton from 'devextreme-vue/button';
	import resizeObserver from 'resize-observer';

	export default {
		name: 'app-core--popup',
		components: {
			DxPopup, PopupBody, DxValidationGroup, DxButton, DxToolbarItem 
		},
		props: {
			width: VueTypes.number.def(960),
			height: VueTypes.number.def(520),
			popupVisible: VueTypes.bool.def(false),
			title: VueTypes.string.def(null),
			closeOnOutsideClick: VueTypes.bool.def(true),
			classes: VueTypes.string.def(null),
			defaultActions: VueTypes.any.def(false),
			validate: VueTypes.any.def(null),
			successText: VueTypes.any.def(null),
			busy: VueTypes.any.def(null),
			onSuccess: VueTypes.any.def(null),
			autosize: VueTypes.any.def(false),
			showMaximize: VueTypes.bool.def(false),
			buttons: VueTypes.array.def([])
		},
		data() {
			return {
				innerPopupVisible: this.popupVisible,
				innerHeight: this.autosize ? 240 : this.height,
				fullScreen: false,
				buttonOptions: {
					icon: 'fullscreen',
					stylingMode: 'text',
					type: 'normal',
					onClick: () => this.fullScreen = !this.fullScreen
				}
			};
		},
		computed: {
			validated() {
				return !this.validate || this.validate();
			}
		},
		watch: {
			popupVisible(v) {
				if (!v)
					this.$emit('hiding', v);
				this.innerPopupVisible = v;
			},
			innerPopupVisible(v) {
				if (!v)
					this.$emit('hiding', v);
			},
			height(v) {
				this.innerHeight = v;
			}
		},
		mounted() {
			this.$unobserve = resizeObserver.observe(this, this.$refs.body.$el, () => this.$emit('resize', this.$refs.body?.$el?.offsetWidth, this.$refs.body?.$el?.offsetHeight));
		},
		destroyed() {
			if (this.$unobserve) this.$unobserve();
			delete this.$unobserve;
		},
		methods: {
			onContentShowing(e) {
				this.$emit('show', true);
				if (this.classes) {
					$(e.component.overlayContent()).parent().addClass(this.classes);
				}
			},
			onContentShown() {
				this.$emit('shown', true);
				if (this.$refs.popupBody?.refresh)
					this.$refs.popupBody?.refresh();
				if (__DEBUG__)
					window.popupWindow = this;
			},
			async processResult(event) {
				if (event === 'success') {
					if (this.onSuccess) {
						const res = await this.onSuccess();
						if (res === false) {
							return;
						}
					}
				}
				this.$emit(event);
				this.$emit('update:popupVisible', false);
			},
			onContentChanged(v) {
				this.processAutoSize(v);
			},
			processAutoSize(contentSize) {
				if (this.autosize) {
					if (__DEBUG__)
						console.debug('Process autosize', { contentSize });
					this.innerHeight = contentSize + (this.title ? 90 : 0) + 100;
				}
			}
		}
	};
</script>
<style lang='scss'>
	.app-core--popup {

	}
</style>
